import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceRulezApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'attendance'
  }

  public getDocumentInfoList(CurrentPageIndex,PageSize,){
    return this.send({},
        "getEntitiesPagelist?current="+CurrentPageIndex+"&size="+PageSize,this.Methods.GET)
  }

}